module.exports = __webpack_public_path__ + "img/icon-chevron-right-filled.5ca215fc.svg";